import { render, staticRenderFns } from "./login-form-old.vue?vue&type=template&id=2da58b31"
import script from "./login-form-old.vue?vue&type=script&lang=js"
export * from "./login-form-old.vue?vue&type=script&lang=js"
import style0 from "./login-form-old.vue?vue&type=style&index=0&id=2da58b31&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports